import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import Alert from "../../../components/alert/Alert";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import ReactHtmlParser from "react-html-parser";
// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getContractPoposal } from "../../../redux/actions/contractActions";

import DatePicker from "react-datepicker";
import moment from "moment";
import {aclUtil} from "../../util"

import "react-datepicker/dist/react-datepicker.css";

const history = createHashHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getContractPoposal: PropTypes.func.isRequired
};

let isLoading = "false";
class ContractDetails extends Component {
  constructor(props) {
    const viewLink = (props.match && props.match.params) && `contractDetails/${props.match.params.contractId}`
    super(props);
    this.state = {
      menuKey: 'VIEW_CONTRACT',
      path: ["Home", "Manage Contract", "Contract Details"],
      links:["home", "contractList", viewLink],
      contractDetails: '',
    };
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handlePageChange = page => {
    let contractIdParams = this.props.match.params.contractId
      ? this.props.match.params.contractId
      : "";
    if (contractIdParams !== "") {
      isLoading = "true";
      this.props.getContractPoposal(contractIdParams, localStorage.getItem("siteID"));
    }
  };

  componentWillMount() {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }
    this.handlePageChange(1);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.contractDetails !== nextProps.contractDetails){
      if(nextProps.contractDetails){
        this.setState({contractDetails: nextProps.contractDetails});
        isLoading = "false";
      }
    }else{
      if(nextProps.contractDetails){
        this.setState({contractDetails: nextProps.contractDetails});
        isLoading = "false";
      }
    }
  }

  render() {
    let contract =
      this.state.contractDetails
        ? this.state.contractDetails
        : {};
    return (
      <div className="col-lg-12 detail-Page">
      {isLoading == "true" ? (
        <div className="loader">
          <p className="loading-message">
            <i>Loading...</i>
          </p>
          <div className="spinner">
            <div className="dot1" />
            <div className="dot2" />
          </div>
        </div>
      ) : (
        ""
      )}
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 text-right">
            <Button
              bsSize="small"
              bsStyle="success"
              onClick={() => history.push("/contractList")}
            >
              Back To Contract List
            </Button>
          </div>
        </div>
        {/**start contract information **/}
        <div className="panel">
          <header className="panel-heading">
            Contract Detail
          </header>

          <div className="panel-body">
            <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <Col md={12} xs={12}>
                {contract ? ReactHtmlParser(contract) : ''}
                </Col>
              </Row>
            </div>
          </div>
        </div>
        {/**end contract information **/}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    contractDetails: state.contractReducer.contractDetail
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { getContractPoposal })
)(ContractDetails);



// WEBPACK FOOTER //
// ./src/app/views/admin/contract/ContractDetails.js